export function routePathFromRedirectUrl(redirectUrl: string) {
  if (
    !redirectUrl.startsWith('http://') &&
    !redirectUrl.startsWith('https://')
  ) {
    return redirectUrl
  }

  const url = new URL(redirectUrl)
  return `${url.pathname}${url.search}${url.hash}`
}
